import * as React from "react"
import { Context } from "./FeedbackContext"

function withContext(Component: any) {
  return function contextComponent(props: any) {
    return (
      <Context.Consumer>
        {(contexts) => <Component {...props} {...contexts} />}
      </Context.Consumer>
    )
  }
}

export default withContext
